import { connect } from 'react-redux';
import { reloadPlayer } from '../../actions';
import PlayerSelectionPanel from '../../components/outputPlayer/PlayerSelectionPanel.js';

const mapStateToProps = state => {
  return {
    name: state.player.name,
    version: state.player.version,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onChange: (name, version) => {
      dispatch(reloadPlayer(name, version));
    },
  };
};

const PlayerSelectionPanelRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerSelectionPanel);

export default PlayerSelectionPanelRedux;
